import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

/**
 * @typedef {Object} PortalProps
 * @property {JSX.Element} children React component to inject in the existing DOM element
 * @property {string} containerId Existing DOM element ID
 */

/**
 * Compose a component in existing DOM tree element through React Portal.
 * @param {PortalProps} props
 * @return {React.ReactPortal}
 */
const Portal = ({ children, containerId }) => {
  const [container, setContainer] = useState(document.getElementById(containerId))
  const el = document.createElement('div')

  const mountPortalComponent = () => {
    if (container) {
      container.appendChild(el)
      return () => container.removeChild(el)
    }
    return () => {}
  }

  useEffect(mountPortalComponent, [el, container])
  useEffect(() => {
    document.addEventListener('drupalajaxready', (event) => {
      if (!container) {
        const containerFound = document.getElementById(containerId)
        setContainer(containerFound)
      }
    })
  }, [])

  if (container) {
    return createPortal(children, el)
  } else {
    return null
  }
}

export default Portal
